<template>
  <div>
    <v-tabs
      v-model="selectedTab"
      color="#2D8CFF"
      background-color="#f2f8ff"
      class="trade-tabs"
      show-arrows
      grow
    >
      <v-tab class="tab text-none" v-for="(item, i) in items" :key="i">
        {{ item.name }}</v-tab
      >
    </v-tabs>
  </div>
</template>
<script>
export default {
  name: "TabComponent",
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
  computed: {
    selectedTabValue() {
      return this.items[this.selectedTab].value;
    },
  },
  watch: {
    selectedTab() {
      this.emitChange();
    },
  },
  methods: {
    emitChange() {
      this.$emit("input", this.selectedTabValue);
    },
  },
  mounted() {},
};
</script>
<style scoped>
.trade-tabs {
  height: 60px;
}
.tab {
  letter-spacing: 0px !important;
}
</style>
